"use client";

import {JSX} from "react";

import Link from "next/link";

import SmartImage from "@/shared/ui/smart-image";

import {useTranslation} from "@/shared/i18n";
import {StarRating} from "@/shared/ui/data-display/rating/star-rating";

import "./property-summary.scss";

interface BookingProperty {
    imageUrl: string;
    title: string;
    location: string;
    rating?: number;
    reviewsCount?: number;
    href: string;
}

export function PropertySummary({imageUrl, title, location, rating, reviewsCount, href}: BookingProperty): JSX.Element {
    const {t} = useTranslation("reviews");
    return (
        <div className="summary-card__property">
            <div className="summary-card__thumb">
                <SmartImage src={imageUrl} alt={title} width={96} height={64} />
            </div>
            <div className="summary-card__prop-texts">
                <Link href={href} className="summary-card__prop-title">
                    {title}
                </Link>
                <div className="summary-card__prop-location">{location}</div>
                {!!reviewsCount && !!rating && (
                    <div className="summary-card__prop-rating">
                        <StarRating name={`${t("count", {count: reviewsCount ?? 0})}`} rating={rating} size="small" />
                    </div>
                )}
            </div>
        </div>
    );
}
